/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Balance,
  BillingUrl,
  CheckoutConfirmation,
  CheckoutStart,
  CheckoutUrl,
  ErrorEnvelope,
  GetCheckoutConfirmationParams,
  OnboardingCheckoutStart,
  TeamSubscription,
  TopUpStart
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetTeamBalanceUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/billing/balance`
}

/**
 * The team's credits: `available` to spend now, `held` by running jobs. Zeros before
 * the first grant. The same stored balance the staff team detail shows.
 * @summary Get Team Balance
 */
export const getTeamBalance = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Balance> => {

  return apiRequest<Balance>(getGetTeamBalanceUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamBalanceQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/billing/balance`
    ] as const;
    }


export const getGetTeamBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getTeamBalance>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamBalance>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamBalanceQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamBalance>>> = ({ signal }) => getTeamBalance(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamBalance>>>
export type GetTeamBalanceQueryError = ErrorType<ErrorEnvelope>


export function useGetTeamBalance<TData = Awaited<ReturnType<typeof getTeamBalance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamBalance>>,
          TError,
          Awaited<ReturnType<typeof getTeamBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamBalance<TData = Awaited<ReturnType<typeof getTeamBalance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamBalance>>,
          TError,
          Awaited<ReturnType<typeof getTeamBalance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamBalance<TData = Awaited<ReturnType<typeof getTeamBalance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamBalance>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Team Balance
 */

export function useGetTeamBalance<TData = Awaited<ReturnType<typeof getTeamBalance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamBalance>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamBalanceQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStartCheckoutUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/billing/checkout`
}

/**
 * The team's Checkout for the plan and cycle: its open one again, or a new one, under
 * live's refusals. Only Stripe's webhooks then give the team its plan.
 * @summary Start Checkout
 */
export const startCheckout = async (teamId: string,
    checkoutStart: CheckoutStart, options?: Parameters<typeof apiRequest>[1]): Promise<CheckoutUrl> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CheckoutUrl>(getStartCheckoutUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(checkoutStart)
  }
);}





export const getStartCheckoutMutationKey = () => ['startCheckout'] as const;

export const getStartCheckoutMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCheckout>>, TError,StartCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startCheckout>>, TError,StartCheckoutMutationVariables, TContext> => {

const mutationKey = getStartCheckoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startCheckout>>, StartCheckoutMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  startCheckout(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof startCheckout>>>
    export type StartCheckoutMutationBody = CheckoutStart
    export type StartCheckoutMutationError = ErrorType<ErrorEnvelope>
    export type StartCheckoutMutationVariables = {teamId: string;data: CheckoutStart}

    /**
 * @summary Start Checkout
 */
export const useStartCheckout = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCheckout>>, TError,StartCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startCheckout>>,
        TError,
        StartCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getStartCheckoutMutationOptions(options), queryClient);
    }
    export const getGetCheckoutConfirmationUrl = (teamId: string,
    params: GetCheckoutConfirmationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/billing/checkout-confirmation?${stringifiedParams}` : `/api/v1/teams/${teamId}/billing/checkout-confirmation`
}

/**
 * Authoritative tracking facts from an owned Checkout's recorded paid invoice.
 * @summary Get Checkout Confirmation
 */
export const getCheckoutConfirmation = async (teamId: string,
    params: GetCheckoutConfirmationParams, options?: Parameters<typeof apiRequest>[1]): Promise<CheckoutConfirmation> => {

  return apiRequest<CheckoutConfirmation>(getGetCheckoutConfirmationUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCheckoutConfirmationQueryKey = (teamId: string,
    params?: GetCheckoutConfirmationParams,) => {
    return [
    `/api/v1/teams/${teamId}/billing/checkout-confirmation`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCheckoutConfirmationQueryOptions = <TData = Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    params: GetCheckoutConfirmationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCheckoutConfirmationQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCheckoutConfirmation>>> = ({ signal }) => getCheckoutConfirmation(teamId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCheckoutConfirmationQueryResult = NonNullable<Awaited<ReturnType<typeof getCheckoutConfirmation>>>
export type GetCheckoutConfirmationQueryError = ErrorType<ErrorEnvelope>


export function useGetCheckoutConfirmation<TData = Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params: GetCheckoutConfirmationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckoutConfirmation>>,
          TError,
          Awaited<ReturnType<typeof getCheckoutConfirmation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCheckoutConfirmation<TData = Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params: GetCheckoutConfirmationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckoutConfirmation>>,
          TError,
          Awaited<ReturnType<typeof getCheckoutConfirmation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCheckoutConfirmation<TData = Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params: GetCheckoutConfirmationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Checkout Confirmation
 */

export function useGetCheckoutConfirmation<TData = Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params: GetCheckoutConfirmationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckoutConfirmation>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCheckoutConfirmationQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOpenPortalUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/billing/portal`
}

/**
 * Stripe's Portal for the team's subscription: a plan change, a cancel at the period's
 * end, the payment method and the invoices. A team whose subscription ended gets a
 * Checkout for its last plan instead, as on live.
 * @summary Open Portal
 */
export const openPortal = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<BillingUrl> => {

  return apiRequest<BillingUrl>(getOpenPortalUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOpenPortalMutationKey = () => ['openPortal'] as const;

export const getOpenPortalMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPortal>>, TError,OpenPortalMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof openPortal>>, TError,OpenPortalMutationVariables, TContext> => {

const mutationKey = getOpenPortalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openPortal>>, OpenPortalMutationVariables> = (props) => {
          const {teamId} = props ?? {};

          return  openPortal(teamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenPortalMutationResult = NonNullable<Awaited<ReturnType<typeof openPortal>>>

    export type OpenPortalMutationError = ErrorType<ErrorEnvelope>
    export type OpenPortalMutationVariables = {teamId: string}

    /**
 * @summary Open Portal
 */
export const useOpenPortal = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPortal>>, TError,OpenPortalMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openPortal>>,
        TError,
        OpenPortalMutationVariables,
        TContext
      > => {
      return useMutation(getOpenPortalMutationOptions(options), queryClient);
    }
    export const getGetTeamSubscriptionUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/billing/subscription`
}

/**
 * The team's stored subscription, confirmed by Stripe's webhook handlers.
 * @summary Get Team Subscription
 */
export const getTeamSubscription = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TeamSubscription> => {

  return apiRequest<TeamSubscription>(getGetTeamSubscriptionUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamSubscriptionQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/billing/subscription`
    ] as const;
    }


export const getGetTeamSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getTeamSubscription>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamSubscriptionQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamSubscription>>> = ({ signal }) => getTeamSubscription(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamSubscription>>>
export type GetTeamSubscriptionQueryError = ErrorType<ErrorEnvelope>


export function useGetTeamSubscription<TData = Awaited<ReturnType<typeof getTeamSubscription>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamSubscription>>,
          TError,
          Awaited<ReturnType<typeof getTeamSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamSubscription<TData = Awaited<ReturnType<typeof getTeamSubscription>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamSubscription>>,
          TError,
          Awaited<ReturnType<typeof getTeamSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamSubscription<TData = Awaited<ReturnType<typeof getTeamSubscription>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Team Subscription
 */

export function useGetTeamSubscription<TData = Awaited<ReturnType<typeof getTeamSubscription>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamSubscription>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamSubscriptionQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStartTopUpUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/billing/top-ups/checkout`
}

/**
 * A new Checkout for a pack of `top_ups.yaml`, under live's refusals. Only Stripe's
 * webhook then gives the team its credits.
 * @summary Start Top Up
 */
export const startTopUp = async (teamId: string,
    topUpStart: TopUpStart, options?: Parameters<typeof apiRequest>[1]): Promise<CheckoutUrl> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CheckoutUrl>(getStartTopUpUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(topUpStart)
  }
);}





export const getStartTopUpMutationKey = () => ['startTopUp'] as const;

export const getStartTopUpMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTopUp>>, TError,StartTopUpMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startTopUp>>, TError,StartTopUpMutationVariables, TContext> => {

const mutationKey = getStartTopUpMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startTopUp>>, StartTopUpMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  startTopUp(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartTopUpMutationResult = NonNullable<Awaited<ReturnType<typeof startTopUp>>>
    export type StartTopUpMutationBody = TopUpStart
    export type StartTopUpMutationError = ErrorType<ErrorEnvelope>
    export type StartTopUpMutationVariables = {teamId: string;data: TopUpStart}

    /**
 * @summary Start Top Up
 */
export const useStartTopUp = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTopUp>>, TError,StartTopUpMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startTopUp>>,
        TError,
        StartTopUpMutationVariables,
        TContext
      > => {
      return useMutation(getStartTopUpMutationOptions(options), queryClient);
    }
    export const getStartOnboardingCheckoutUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/billing/onboarding-checkout`
}

/**
 * The normal plan Checkout, returning to the authorized brand's saved flow.
 * @summary Start Onboarding Checkout
 */
export const startOnboardingCheckout = async (teamId: string,
    brandId: string,
    onboardingCheckoutStart: OnboardingCheckoutStart, options?: Parameters<typeof apiRequest>[1]): Promise<CheckoutUrl> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CheckoutUrl>(getStartOnboardingCheckoutUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(onboardingCheckoutStart)
  }
);}





export const getStartOnboardingCheckoutMutationKey = () => ['startOnboardingCheckout'] as const;

export const getStartOnboardingCheckoutMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startOnboardingCheckout>>, TError,StartOnboardingCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startOnboardingCheckout>>, TError,StartOnboardingCheckoutMutationVariables, TContext> => {

const mutationKey = getStartOnboardingCheckoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startOnboardingCheckout>>, StartOnboardingCheckoutMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  startOnboardingCheckout(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartOnboardingCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof startOnboardingCheckout>>>
    export type StartOnboardingCheckoutMutationBody = OnboardingCheckoutStart
    export type StartOnboardingCheckoutMutationError = ErrorType<ErrorEnvelope>
    export type StartOnboardingCheckoutMutationVariables = {teamId: string;brandId: string;data: OnboardingCheckoutStart}

    /**
 * @summary Start Onboarding Checkout
 */
export const useStartOnboardingCheckout = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startOnboardingCheckout>>, TError,StartOnboardingCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startOnboardingCheckout>>,
        TError,
        StartOnboardingCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getStartOnboardingCheckoutMutationOptions(options), queryClient);
    }
